import React from 'react';
import { RBHBox, RBHText } from '../../../../../../shared/components';
import styleText from '../../../../../../shared/components/rbh-text/styles';
import { FormattedMessage } from 'react-intl';
import styles from './styles'


export const Header = () => {
	return (
		<RBHBox style={styles.headerStyle}>
			<RBHText
				style={styleText.headerText}
				text={'main.cat_category'}
				data-testid={'cat_category'}
				id={'cat_category'}
			/>
            <FormattedMessage id={'main.cat_category.subtitle'} />
            
		</RBHBox>
	);
};
